import { Industry } from '../../../store/roles/types';
import { IOption } from '@skf/bt-wind-rail-commonlibrary/dist/components/form/types';

export const getIndustryByName = (
  industries: Industry[] = [],
  industryName: string = ''
): Industry | undefined =>
  industries.find((industry) => industry.industryName === industryName);

export const getIndustryOptions = (industries: Industry[] = []): IOption[] =>
  industries.map((industry) => ({
    value: industry.industryCode,
    label: industry.industryName,
    labelToShow: industry.industryName,
  }));

export const getPortalOptions = (
  industries: Industry[] = [],
  industryName: string = ''
): IOption[] => {
  return (
    industries
      .find((ind) => ind.industryName === industryName)
      ?.industryPortals.map((portal) => {
        return { value: portal, label: portal, labelToShow: portal };
      }) || []
  );
};

export const getPriorityOptions = (
  industries: Industry[] = [],
  industryName: string = ''
): IOption[] =>
  (getIndustryByName(industries, industryName)?.priorities || []).map(
    (priority) => ({
      value: priority + '',
      label: priority + '',
      labelToShow: priority + '',
    })
  );

export const getUserWebRolesOptions = (
  industries: Industry[] = [],
  industryName: string = '',
  btPortalIndustry: string = '',
  userWebRoles: string[] = []
): IOption[] => {
  const webRolesPortal = (
    getIndustryByName(industries, industryName)?.userWebRoles || []
  )?.find((userWebRole) => userWebRole.btPortalIndustry === btPortalIndustry);

  const filteredRoles = webRolesPortal?.userWebRoleName.filter(
    (x) => userWebRoles.indexOf(x) === -1
  );

  return (filteredRoles || []).map((userWebRole) => ({
    value: userWebRole,
    label: userWebRole,
    labelToShow: userWebRole,
  }));
};
